import * as React from 'react';
import { connect } from 'react-redux';

import { PortalHeader } from '../PortalHeader';

import CheckCircle from '@mui/icons-material/CheckCircle';
import QuestionCircle from '@mui/icons-material/Help';
import { Theme, ThemeProvider } from '@mui/material/styles';
import { BrandConfig, GetBrandConfig } from '../../Store/Tenant';

import { CreateStdTheme } from '../../Utils/Style';

import { ApplicationState } from '../../Store';
import { useSearchParams } from 'react-router-dom';

import { GetPortalText } from '../../Store/PortalAssets';
import { PortalTextBorrowerEmailConfirmation } from '../../Models/Api/strongbox.financialportal';

type InjectedReduxState = {
    confirmationParagraphs: string[];
    brandConfig: BrandConfig;
};

type InjectedActionCreators = {
};

type EmailConfirmProps = {
    delayConfirm?: boolean
};

type Props = EmailConfirmProps & InjectedActionCreators & InjectedReduxState;

const EmailConfirmComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        confirmationParagraphs,
        delayConfirm
    } = props;

    const [searchParams] = useSearchParams();

    React.useEffect(() => {
        if (!!delayConfirm) {
            let submissionId = searchParams.get('submissionId');
            let confirmUrl = `/submissions/${submissionId}/confirm`;

            //navigate(confirmUrl, {replace: true});
            const idTimer = setTimeout(() => { window.location.replace(confirmUrl); }, 2000);

            return () => clearTimeout(idTimer);
        }

        // I want this to execute equivalent to componentDidMount so this is appropriate
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [muiTheme] = React.useState<Theme>(() => {
        return CreateStdTheme(props.brandConfig);
    });

    const imgForDisplay = React.useMemo(() => {
        const iconStyle: React.CSSProperties = {
            height: '100px',
            width: '100px'
        }

        return !!delayConfirm ?
            (
                <QuestionCircle color={'primary'} style={iconStyle} />
            ) :
            (
                <CheckCircle color={'primary'} style={iconStyle} />
            );
    }, [delayConfirm])

    const renderParagraphs = (): React.ReactNode => {
        const paragraphs: React.ReactNode[] = [];

        confirmationParagraphs.forEach((paragraph, indexParagraph) => {
            if (indexParagraph === 0) {
                paragraphs.push((
                    <div style={{ marginTop: '40px' }}>
                        <h1>{paragraph}</h1>
                    </div>
                ));
            } else {
                paragraphs.push((
                    <div style={{ marginTop: '20px' }}>
                        <h3>{paragraph}</h3>
                    </div>
                ));
            }
        });

        return (
            <>
                {paragraphs}
            </>
        );
    }

    return (
        <div>
            <PortalHeader hideMenu={true} flow={'borrower'} />
            <ThemeProvider theme={muiTheme}>
                <div className={`full-screen-region borrower-region content-region`}>
                    <div>
                        {imgForDisplay}
                        {renderParagraphs()}
                    </div>
                </div>
            </ThemeProvider>
        </div>
    );
}

export const EmailConfirm = connect<InjectedReduxState, InjectedActionCreators, EmailConfirmProps, ApplicationState>(
    (appState: ApplicationState, props: EmailConfirmProps) => {
        const confirmationText = GetPortalText<PortalTextBorrowerEmailConfirmation>(appState, 'borrowerEmailConfirmation');

        let confirmationParagraphs: string[] = [];

        if (!!props.delayConfirm) {
            confirmationParagraphs = [
                confirmationText?.confirmingP1 || '',
                confirmationText?.confirmingP2 || '',
            ]
        } else {
            confirmationParagraphs = [
                confirmationText?.confirmedP1 || '',
                confirmationText?.confirmedP2 || '',
            ]
        }

        const result = {
            confirmationParagraphs,
            brandConfig: GetBrandConfig(appState),
        };

        return result;
    },

)(EmailConfirmComponent);
